module.exports = __webpack_public_path__ + "fonts/KaTeX_Fraktur-Bold.b9d7c449.ttf";